import React from 'react';
import { Box, Icon, Link, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './FeesAndSalesTaxCheckboxes.styles';
import useBapCtaClickGtm from '../../core/gtm/hooks/useBapCtaClickGtm';
import useFetchCurrentVehicleFinancialCalculatorSummary from '../../core/apiHooks/useFetchSummary';
import usePriceBreakdownModal from './usePriceBreakdownModal';
import { LabeledCheckbox } from './shared/LabeledItem';
import { selectPaymentOptions } from '../../core/reducers/financialCalculators';
import { useAppSelector } from '../../core/utils';
import useBapRegisterUserInteraction from '../../utils/hooks/bap/useBapRegisterUserInteraction';
const Container = themeStyles.apply(Box, 'Container');
const CheckboxesContainer = themeStyles.apply(Box, 'CheckboxesContainer');
const PriceBreakdownLink = themeStyles.apply(Link, 'PriceBreakdownLink');
const FeesAndSalesTaxCheckboxes = ({ calculatorId, disableAllFields, showPriceBreakdown, onIncludeFeesChange, onOverriddenIsSellingProvinceChange, componentType, }) => {
    const { t } = useTranslation();
    const { fireGtmEvent } = useBapCtaClickGtm();
    const { registerUserInteraction } = useBapRegisterUserInteraction('paymentCalculator');
    const { openModal } = usePriceBreakdownModal();
    const { isLoading, error, summary } = useFetchCurrentVehicleFinancialCalculatorSummary(calculatorId);
    const { overriddenIsSellingProvince, includeFees } = useAppSelector(state => selectPaymentOptions(state, calculatorId));
    const handleIncludeFeesClick = () => {
        registerUserInteraction();
        const newValue = !overriddenIsSellingProvince;
        if (onOverriddenIsSellingProvinceChange) {
            onOverriddenIsSellingProvinceChange(newValue);
        }
        if (!newValue && includeFees) {
            if (onIncludeFeesChange) {
                onIncludeFeesChange(false);
            }
        }
    };
    const handleIncludeTaxesClick = () => {
        registerUserInteraction();
        const newValue = !includeFees;
        if (onIncludeFeesChange) {
            onIncludeFeesChange(newValue);
        }
        if (newValue) {
            if (onOverriddenIsSellingProvinceChange) {
                onOverriddenIsSellingProvinceChange(true);
            }
        }
    };
    return (React.createElement(Container, null,
        React.createElement(CheckboxesContainer, null,
            React.createElement(LabeledCheckbox, { checked: overriddenIsSellingProvince, onClick: handleIncludeFeesClick, label: t('Shared.Common.includeFreightCheckboxLabel'), tooltipText: t('Shared.Common.includeFeesTooltipText'), name: "fees", disabled: disableAllFields }),
            React.createElement(LabeledCheckbox, { checked: includeFees, onClick: handleIncludeTaxesClick, label: t('Shared.Common.includeTaxesCheckboxLabel'), tooltipText: t('Shared.Common.includeTaxesTooltipText'), name: "tax", disabled: disableAllFields })),
        React.createElement(Optional, { when: showPriceBreakdown && !isLoading && !error && !!summary },
            React.createElement(PriceBreakdownLink, { href: true, styling: "tertiary2", "data-testid": "price-breakdown-button", onClick: () => {
                    openModal();
                    fireGtmEvent({
                        componentType,
                        ctaType: 'price breakdown',
                        ctaPlacement: 'summary',
                        linkText: 'price breakdown',
                    });
                } },
                t('Pages.Bap.priceBreakdownButton'),
                React.createElement(Icon, { ml: "12px", height: "12px", name: "arrowRight", iconColor: "blue" })))));
};
export default FeesAndSalesTaxCheckboxes;
